//------------------------------------------------------ externos
//------------------------------------------------------ elementos
import MovimientoVehiculoAccess from "../components/access/accessButtons/MovimientoVehiculoAccess";
import MovimientoPersonaAccess from "../components/access/accessButtons/MovimientoPersonaAccess";
//------------------------------------------------------ funciones y data

/* MITAD Y MITAD, Y NO CUATRO BARRAS DE PANTALLA COMPLETA.
 *
 * Lo que sobraba no era el ancho: era que al abrir un alta, el formulario
 * —que se dibuja fijo contra el borde derecho— tapaba la lista entera. Uno
 * pierde de vista qué estaba cargando y qué le falta cargar, que es
 * justamente la pregunta que tiene abierta mientras completa.
 *
 * Con la lista quieta en la mitad izquierda, las dos cosas se ven a la vez.
 * En pantalla angosta vuelve a ser una sola columna: ahí no hay dos mitades
 * que repartir y el formulario sí tiene que ocuparlo todo.
 */
const Resources = () => {
  console.log("[Render] Seccion de Recursos de la empresa");

  return (
    <section className="section-container">

      <div className="sections-options-group cargar-mitad">
        <div className="section-options-row-right">
          <div className="sections-options">
            <MovimientoPersonaAccess />
            <MovimientoVehiculoAccess tipo={"tractor"} />
            <MovimientoVehiculoAccess tipo={"furgon"} />
            <MovimientoVehiculoAccess />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resources;
